/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var Regions;

(function (Regions) {
  Regions["US"] = "US";
  Regions["EU"] = "EU";
  Regions["GB"] = "GB";
})(Regions || (Regions = {}));